<template>
  <div class="properties-centent kk-checkbox" ref="propertiesCentent">
    <a-form>
      <a-form-item label="查询编码">
        <a-input v-model="dataSource.no" placeholder="请输入" />
      </a-form-item>
      <a-form-item label="查询描述">
        <a-input v-model="dataSource.name" placeholder="请输入" />
      </a-form-item>
      <a-form-item label="类型">
        <a-radio-group buttonStyle="solid" v-model="dataSource.type">
          <a-radio-button value="1">检索方案</a-radio-button>
          <a-radio-button value="2">数据显示</a-radio-button>
          <a-radio-button value="3">查询报表</a-radio-button>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="数据源类型">
        <a-radio-group buttonStyle="solid" v-model="dataSource.queryType">
          <a-radio-button value="1">API</a-radio-button>
          <a-radio-button value="2">SQL</a-radio-button>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="查询SQL">
        <a-textarea
          :style="{width:200}"
          :autosize="{
            minRows: 4,
            maxRows: 500
          }"
          :rows="4"
          v-model="dataSource.sql"
        />
      </a-form-item>
      <a-form-item label="参数模板">
        <a-textarea
          :style="{width:200}"
          :autosize="{
            minRows: 4,
            maxRows: 20
          }"
          :rows="4"
          v-model="dataSource.paramModel"
        />
      </a-form-item>
      <a-form-item label="api-method">
        <a-radio-group buttonStyle="solid" v-model="dataSource.apiDesc.method">
          <a-radio-button value="get">get</a-radio-button>
          <a-radio-button value="post">post</a-radio-button>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="api-url">
        <a-input v-model="dataSource.apiDesc.url" placeholder="请输入URL" />
      </a-form-item>
      <a-form-item label="api-headers">
        <a-textarea
          :style="{width:200}"
          :autosize="{
            minRows: 4,
            maxRows: 200
          }"
          :rows="4"
          v-model="dataSource.apiDesc.headers"
        />
      </a-form-item>

      <a-form-item label="查询列配置">
        <a-textarea
          :style="{width:200}"
          :autosize="{
            minRows: 4,
            maxRows: 200
          }"
          :rows="4"
          v-model="dataSource.columns"
        />
      </a-form-item>

      <a-form-item >
        <p>-</p>
        <p>-</p>
      </a-form-item>
    </a-form>
  </div>
</template>
<script>
  // import changeOption from "@/components/ChangeOption/index.vue";
  import kCheckbox from '@/components/KCheckbox/index.vue';
  export default {
    name: 'TableProperties',
    components: {
      //   changeOption,
      kCheckbox
    },
    props: {
      dataSource: {
        type: Object,
        required: true
      },
      previewOptions: {
        type: Object,
        required: true
      }
    },
    methods: {
      setOropertiesCentent() {
        this.$refs.propertiesCentent.style.height =
          document.body.clientHeight - 160 + 'px';
      }
    },
    mounted() {
      this.setOropertiesCentent();
      window.addEventListener('resize', this.setOropertiesCentent, true);
    },
    destroyed() {
      // 取消监听
      window.removeEventListener('resize', this.setOropertiesCentent, true);
    }
  };
</script>
<style lang="less" scoped>
  .change-col-box {
    > div {
      padding: 5px;
      display: flex;
      > label {
        text-align: right;
        padding-right: 8px;
        display: block;
        font-size: 16px;
        width: 45px;
      }
    }
  }
</style>
